/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { PostMicrosoftLogin, PostMicrosoftCallback } from '@/infrastructure/network/Monitaro/requests/o_auth_microsoft'

export default class OAuthMicrosoft extends MonitaroGatewayBase {
  async PostMicrosoftLogin() {
    const { url } = await this.apiClient.request(new PostMicrosoftLogin())
    return url
  }

  async PostMicrosoftCallback(params: any) {
    const { result } = await this.apiClient.request(new PostMicrosoftCallback(params))
    return result
  }
}
